import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import {Link} from "react-router-dom"; 
import chooseImg1 from "../images/what-is-typeform.jpg"
import $ from 'jquery';

export default class FreeAssesment extends Component {
    // componentDidMount() {
    //     ("#form-free-assessment").hide();
    //     $("#get-free-assesment").click(function(){
    //       $("#form-free-assessment").show();
    //     });
    // }
    getAssesment(){
      $("#form-free-assessment").show();
      $("#get-free-assesment").hide();
    }
    
    componentDidMount() {

      // $("#emailSubwrapper").addClass("get-free-assesment-active");
      
      //   $(".form-main-wrapper").scroll(function() {
      //     var topOfDivScroll = $("#emailSubwrapper").offset().top ;
      //     var topOfDivScroll1 = $("#nameSubwrapper").offset().top ;
      //     var topOfDivScroll2 = $("#chooseSubwrapper").offset().top ;
      //     var topOfDivScroll3 = $("#dateSubwrapper").offset().top ;
      //     var topOfDivScroll4 = $("#questionSubwrapper").offset().top ;
      //     var topOfDivScroll5 = $("#resumeSubwrapper").offset().top ;
      //     var topOfDivScroll6 = $("#question2Subwrapper").offset().top ;

      //     if ($(this).scrollTop() > topOfDivScroll) {
      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
      //       $("#emailSubwrapper").addClass("get-free-assesment-active");
      //     } 
      //     if ($(this).scrollTop() > topOfDivScroll1) {
      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
      //       $("#nameSubwrapper").addClass("get-free-assesment-active");
      //     } 
      //     if (($(this).scrollTop() > (topOfDivScroll2)) ) {
      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
      //       $("#chooseSubwrapper").addClass("get-free-assesment-active");
      //     } 
      //     if ($(this).scrollTop() > (topOfDivScroll3)) {
      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
      //       $("#dateSubwrapper").addClass("get-free-assesment-active");
      //     } 
      //     if ($(this).scrollTop() > topOfDivScroll4) {
      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
      //       $("#questionSubwrapper").addClass("get-free-assesment-active");
      //     } 
      //     if ($(this).scrollTop() > topOfDivScroll5) {
      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
      //       $("#resumeSubwrapper").addClass("get-free-assesment-active");
      //     } 
      //     if ($(this).scrollTop() > topOfDivScroll6) {
      //       $(".form-main-subwrapper").removeClass("get-free-assesment-active");
      //       $("#question2Subwrapper").addClass("get-free-assesment-active");
      //     } 
      //   });
        
      
    }
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content free-assessment-wrapper">    
            <div className="container px-0 pt-5">
                {/* <div className='page-top-section'>
                  <div className='page-top-head'>
                    <h4>Lost password</h4>
                    <p className='breadcrumb'>
                      <a href="/">Home</a>
                      <span className='px-2'> / </span>
                      <a href="/my-account">My account</a>
                      <span className='px-2'> / </span>
                      <a href="/lost-password">Lost password</a>
                    </p>
                  </div>
                </div> */}
                
                <div className='col-lg-8 free-assessment-main' style={{margin:"auto"}}>
                  <div className='get-free-assesment' id="get-free-assesment">
                    <p className='free-assessment-text'>Get your free assesment</p>
                      <div className="form-group mt-4">
                        <button type="submit" className="btn btn-warning" onClick={() => this.getAssesment()}>
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M5 20c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l8.646-8.646-8.646-8.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l9 9c0.195 0.195 0.195 0.512 0 0.707l-9 9c-0.098 0.098-0.226 0.146-0.354 0.146z"></path></svg>                        Next</button>
                      </div>
                  </div>
                  <form className='form-main-wrapper' id="form-free-assessment" style={{display:"none"}}>
                    <div className='form-main-subwrapper' id='emailSubwrapper' style={{paddingTop:"50px"}}>
                      <div className="form-group">
                        <label className='free-assessment-text' for="exampleFormControlInput1">Email </label>
                        <input type="email" className="form-control" />
                      </div>
                      <div className="form-group mt-4">
                        <a href="#nameSubwrapper" className="btn btn-warning">
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                        Next</a>
                      </div>
                    </div>
                    <div className='form-main-subwrapper' id='nameSubwrapper'>
                      <div>
                        <a href="#emailSubwrapper">
                          <svg className='arrow-svg-black' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                          Back
                        </a>
                      </div>
                      <div className="form-group">
                        <label className='free-assessment-text' for="exampleFormControlInput1">Name </label>
                        <input type="name" className="form-control" />
                      </div>
                      <div className="form-group mt-4">
                        <a href="#chooseSubwrapper" className="btn btn-warning">
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                        Next</a>
                      </div>
                    </div>
                    <div className='form-main-subwrapper' id='chooseSubwrapper'>
                      <div>
                        <a href="#nameSubwrapper">
                          <svg className='arrow-svg-black' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                          Back
                        </a>
                      </div>
                      <div className="form-group">
                        <label className='free-assessment-text d-block' for="exampleFormControlInput1">choose one </label>
                        <div className='chooseimg1'>
                          <img src={chooseImg1}></img>
                        </div>
                        <div className='chooseimg1'>
                          <img src={chooseImg1}></img>
                        </div>
                      </div>
                      <div className="form-group mt-4">
                        <a href="#dateSubwrapper" className="btn btn-warning">
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                        Next</a>
                      </div>
                    </div>
                    <div className='form-main-subwrapper' id='dateSubwrapper'>
                      <div>
                        <a href="#chooseSubwrapper">
                          <svg className='arrow-svg-black' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                          Back
                        </a>
                      </div>
                      <div className="form-group">
                        <label className='free-assessment-text' for="exampleFormControlInput1">date </label>
                        <input type="date" className="form-control" />
                      </div>
                      <div className="form-group mt-4">
                        <a href="#questionSubwrapper" className="btn btn-warning">
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                        Next</a>
                      </div>
                    </div>
                    <div className='form-main-subwrapper' id='questionSubwrapper'>
                      <div>
                        <a href="#dateSubwrapper">
                          <svg className='arrow-svg-black' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                          Back
                        </a>
                      </div>
                      <div className="form-group">
                        <label className='free-assessment-text' for="exampleFormControlInput1">question 1 </label>
                        <div className='mb-2'><button type='button' className='btn'>america</button></div>
                        <div className='mb-2'><button type='button' className='btn'>america</button></div>
                      </div>
                      <div className="form-group mt-4">
                        <a href="#resumeSubwrapper" className="btn btn-warning">
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                        Next</a>
                      </div>
                    </div>
                    <div className='form-main-subwrapper' id='resumeSubwrapper'>
                      <div>
                        <a href="#questionSubwrapper">
                          <svg className='arrow-svg-black' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                          Back
                        </a>
                      </div>
                      <div className="form-group">
                        <label className='free-assessment-text' for="exampleFormControlInput1">Resume </label>
                        <input type="email" className="form-control" />
                      </div>
                      <div className="form-group mt-4">
                        <a href="#question2Subwrapper" className="btn btn-warning">
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                        Next</a>
                      </div>
                    </div>
                    <div className='form-main-subwrapper' id='question2Subwrapper'>
                      <div>
                        <a href="#resumeSubwrapper">
                          <svg className='arrow-svg-black' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                          Back
                        </a>
                      </div>
                      <div className="form-group">
                        <label className='free-assessment-text' for="exampleFormControlInput1">question 2 </label>
                       <div>
                        <input type="checkbox"/> Kerala
                       </div>
                       <div>
                        <input type="checkbox" /> Kerala
                       </div>
                      </div>
                      <div className="form-group mt-4">
                      <a href="#free-ass-submit" className="btn btn-warning">
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                        Next</a>
                      </div>
                    </div>
                    <div className='form-main-subwrapper' id="free-ass-submit">
                      <div className="form-group mt-4">
                        <div>
                          <a href="#question2Subwrapper">
                            <svg className='arrow-svg-black' aria-hidden="true" viewBox="0 0 20 20"><path d="M9.854 19.354l6-6c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.146 5.146v-16.293c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v16.293l-5.146-5.146c-0.195-0.195-0.512-0.195-0.707 0-0.098 0.098-0.146 0.226-0.146 0.354s0.049 0.256 0.146 0.354l6 6c0.195 0.195 0.512 0.195 0.707 0z"></path></svg>
                            Back
                          </a>
                        </div>
                        <button type="submit" className="btn btn-warning">
                        <svg className='arrow-svg' aria-hidden="true" viewBox="0 0 20 20"><path d="M5.5 17.5c-0.128 0-0.256-0.049-0.354-0.146l-5-5c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l4.646 4.646 13.646-13.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-14 14c-0.098 0.098-0.226 0.146-0.354 0.146z"></path></svg>                        
                        Submit</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
            
        </div>
        <Footer></Footer>
      </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/ivano/free-assesment.jsx